// Property types are stored as canonical spellings ("ApartmentUnitFlat") so a
// rule and a property compare like for like. Only the compound ones need
// spelling out; the rest just want their words separated.
const PROPERTY_TYPE_LABELS = {
  ApartmentUnitFlat: "Apartment / Unit / Flat",
  VacantLand: "Vacant Land",
  AcreageSemiRural: "Acreage / Semi-Rural",
};

export const formatPropertyType = (type) =>
  PROPERTY_TYPE_LABELS[type] ||
  String(type || "").replace(/([a-z])([A-Z])/g, "$1 $2");

// "internetPortals" -> "Internet Portals"
export const formatProductCategory = (category) =>
  !category
    ? "Other"
    : category === "imGroup"
      ? "IM Group"
      : category
          .replace(/([a-z])([A-Z])/g, "$1 $2")
          .replace(/\b\w/g, (c) => c.toUpperCase());

export const formatCurrency = (value) => {
  if (value === undefined || value === null) return "N/A";
  return "$" + new Intl.NumberFormat().format(value);
};

export function formatDateToAEDT(date) {
  // If date is invalid or null, use current date and time
  const dateObj = date ? new Date(date) : new Date();

  // Options for date formatting
  const dateOptions = {
    timeZone: "Australia/Sydney",
    day: "2-digit",
    month: "short",
    year: "numeric",
  };

  const timeOptions = {
    timeZone: "Australia/Sydney",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
    timeZoneName: "short",
  };

  const dateFormatter = new Intl.DateTimeFormat("en-AU", dateOptions);
  const timeFormatter = new Intl.DateTimeFormat("en-AU", timeOptions);

  // Format date and time separately
  const formattedDate = dateFormatter.format(dateObj); // e.g., "17 Jun 2024"
  const formattedTimeWithZone = timeFormatter.format(dateObj); // e.g., "2:15 pm AEDT"

  // Extract time and timezone abbreviation
  const timeWithZoneParts = formattedTimeWithZone.split(" ");
  const time = timeWithZoneParts[0] + timeWithZoneParts[1].toLowerCase(); // "2:15pm"
  const timeZoneAbbreviation = timeWithZoneParts[2]; // "AEDT" or "AEST"

  // Split date into components
  const dateParts = formattedDate.split(" "); // ["17", "Jun", "2024"]
  const day = dateParts[0];
  const month = dateParts[1];
  const year = dateParts[2];

  // Construct the final formatted date
  const finalFormattedDate = `${day}/${month}/${year} ${time}(${timeZoneAbbreviation})`;

  return finalFormattedDate;
}

export const isValidUrl = (url) => {
  return url && url.startsWith("https");
};

export const formatDate = (date) => {
  if (!date) return null;

  return new Date(date).toLocaleDateString("en-AU", {
    day: "2-digit",
    month: "long",
    year: "numeric",
    timeZone: "Australia/Sydney",
  });
};

export const formatDateTime = (date) => {
  if (!date) return null;

  return new Date(date).toLocaleString("en-AU", {
    day: "2-digit",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    timeZone: "Australia/Sydney",
  });
};